class ArticleCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView: 1.25,
          spacing: 2,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3,
            },
          },
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('article-carousel')) {
  customElements.define('article-carousel', ArticleCarousel)
}
